
module.directive('sorter', function() {
    return {
        restrict: 'A',
        require: ['sorter', '?ngModel'],
        scope: {
            sort: '=?sorter',
            direction: '=?sortDirection',
        },
        link: function(scope, element, attrs, controller) {
            if (controller[1]) {
                controller[0].setNgModel(controller[1]);
            }
        },
        controller: ['$scope', function($scope) {
            var ctrl = this,
                controls = {};

            function setSort(sort, direction) {
                for (var name in controls) {
                    controls[name](sort === name ? direction : false);
                }
            }

            this.registerControl = function(name, setter) {
                controls[name] = setter;
                controls[name]($scope.sort === name ? $scope.direction : false);
            };

            this.controlClicked = function(name) {
                if ($scope.sort === name && $scope.direction === 'asc') {
                    $scope.direction = 'desc';
                } else {
                    $scope.sort = name;
                    $scope.direction = 'asc';
                }

                if (this.ngModel) {
                    this.ngModel.$setViewValue(
                        ($scope.direction === 'asc' ? '' : '-') + $scope.sort);
                }

            };

            this.$render = function() {
                var sort = this.ngModel.$viewValue || this.ngModel.$modelValue;
                sort = sort.trim();
                if (sort[0] === '+' || sort[0] === '-') {
                    $scope.sort = sort.substring(1);
                    $scope.direction = sort[0] === '+' ? 'asc' : 'desc';
                } else {
                    $scope.sort = sort;
                    $scope.direction = 'asc';
                }
            }

            this.setNgModel = function(ngModelController) {
                this.ngModel = ngModelController;
                this.ngModel.$render = this.$render.bind(this);
            }

            $scope.$watchGroup(['sort', 'direction'], function(newValues) {
                setSort(newValues[0], newValues[1]);
            });

        }],
    };
});


module.directive('sorterControl', function() {
    return {
        restrict: 'A',
        require: '^sorter',
        link: function(scope, element, attrs, dybSort) {
            var name = attrs.sorterControl;

            attrs.$observe('sorterControl', function(value) {
                name = value;
            });

            dybSort.registerControl(name, function(status) {
                element.removeClass('sort-asc sort-desc');
                if (status) {
                    element.addClass('sort-' + status);
                }
            });

            element.on('click', function(event) {
                scope.$apply(dybSort.controlClicked.bind(dybSort, name));
            });
        }
    };
});


module.directive('sorterIcon', function() {
    return {
        restrict: 'E',
        templateUrl: 'util/widgets/sorterIcon',
        scope: {options: '=', _column: '=column', _direction: '=direction'},
        link: function(scope, element, attrs) {

            Object.defineProperty(scope, 'column', {
                get: function() { return scope._column;},
                set: function(value) { scope._column = value; },
            });

            Object.defineProperty(scope, 'direction', {
                get: function() { return scope._direction; },
                set: function(value) { scope._direction = value; },
            });

            scope.$watch("options", function(options) {
                if (!angular.isArray(options) || options.length === 0) {
                    return;
                }
                var i;
                scope.labelMap = {};
                for (i = 0; i < options.length; i++) {
                    scope.labelMap[options[i].name] = options[i].label;
                }

                if (!scope.direction) {
                    scope.direction = options[0].desc ? "desc" : "asc";
                }

                if (!scope.column) {
                    scope.column = options[0];
                }
            }, true);
        },
    };
});
